// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"a41b9740","216":"f0560089","435":"0c5d682d","723":"5fa36a49","731":"a43fc28c"}[chunkId] + ".chunk.js";
};